import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Calendar } from 'lucide-react';
export function Hero() {
  return <section className="pt-32 pb-20 md:pt-40 md:pb-28 px-6 bg-white overflow-hidden" data-id="element-70">
      <div className="max-w-4xl mx-auto text-center" data-id="element-71">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} data-id="element-72">
          <span className="inline-block py-1 px-3 rounded-full bg-brand-50 text-brand-700 text-sm font-medium mb-6 border border-brand-100" data-id="element-73">
            La nueva forma de vender en Chile
          </span>
          <h1 className="text-4xl md:text-6xl font-extrabold tracking-tight text-gray-900 mb-6 leading-[1.1]" data-id="element-74">
            Vende tu propiedad sin corredor, <br className="hidden md:block" data-id="element-75" />
            <span className="text-brand-600" data-id="element-76">
              pero con un sistema que funciona
            </span>
          </h1>
          <p className="text-lg md:text-xl text-gray-600 mb-10 max-w-2xl mx-auto leading-relaxed" data-id="element-77">
            Si publicas solo, te llaman corredores. Con nosotros, hablas con
            compradores reales y vendes mejor.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-78">
            <button className="w-full sm:w-auto flex items-center justify-center gap-2 bg-brand-600 hover:bg-brand-700 text-white px-8 py-3.5 rounded-full font-medium transition-all shadow-sm hover:shadow-md text-lg" data-id="element-79">
              Agendar diagnóstico gratuito
              <ArrowRight size={18} data-id="element-80" />
            </button>
            <button className="w-full sm:w-auto flex items-center justify-center gap-2 bg-white hover:bg-gray-50 text-gray-500 border border-gray-200 px-8 py-3.5 rounded-full font-medium transition-all text-base" data-id="element-81">
              <Calendar size={18} className="text-gray-400" data-id="element-82" />
              Evaluar mi propiedad
            </button>
          </div>
        </motion.div>
      </div>
    </section>;
}